<template>
  <b-container>
    <b-card class="mt-5 mb-5 iq-border-radius-20">
      <p v-if="allStoreInfo.policies.length > 0" class="about-merchant-policies-privacy text-black">{{allStoreInfo.policies}}</p>
      <p v-else class="about-merchant-policies-privacy text-black text-center font-weight-bold">لا يوجد</p>
    </b-card>
  </b-container>
</template>

<script>
import marketPlace from '@/modules/servicePages/marketplace/services/marketplace'
export default {
  name: 'privacyPolicyRoutes',
  data () {
    return {
      allStoreInfo: {}
    }
  },
  methods: {
    getStoreInfo () {
      marketPlace.getStoreInfo(this.$route.params.slogan).then(res => {
        this.allStoreInfo = res.data
      })
    }
  },
  created () {
    this.getStoreInfo()
  }
}
</script>

<style>
.about-merchant-policies-privacy{
  font-size: 22px;
}
@media (max-width: 992px) {
  .about-merchant-policies-privacy{
    font-size: 16px !important;
  }
}
</style>
